document.addEventListener('DOMContentLoaded', function() {
  (function() {
    var navbar = document.querySelector('.m-menu-container');
    var navItems = document.querySelectorAll('.m-menu__item');
    var navbarWidth = navbar.offsetWidth;
    var navNextBtn = document.getElementById('navNextBtn');
    var navPrevBtn = document.getElementById('navPrevBtn');
  
    function updateArrowColor() {
      var lastNavItem = navItems[navItems.length - 1];
      var lastNavItemRight = lastNavItem.getBoundingClientRect().right -10 ;
  
      if (lastNavItemRight <= navbarWidth) {
        navNextBtn.classList.add('disabled');
      } else {
        navNextBtn.classList.remove('disabled');
      }
  
      if (navbar.scrollLeft <= 0) {
        navPrevBtn.classList.add('disabled');
      } else {
        navPrevBtn.classList.remove('disabled');
      }
  
      var totalWidth = 0;
      
      navItems.forEach(function(item, index) {
        var style = window.getComputedStyle(item);
        totalWidth += item.offsetWidth + parseInt(style.marginLeft) + parseInt(style.marginRight) + parseInt(style.paddingLeft) + parseInt(style.paddingRight) -1;
        
      });
      
      if ( totalWidth <= navbarWidth) {
        navPrevBtn.style.display = 'none';
        navNextBtn.style.display = 'none';
      } else {
        navPrevBtn.style.display = 'block';
        navNextBtn.style.display = 'block';
      }
      //console.log('totalWidth: ',totalWidth);
      //console.log('navbarWidth:',navbarWidth);
    }
  
    function handleResize() {
      navbarWidth = navbar.offsetWidth;
      updateArrowColor();
    }
  
    window.addEventListener('resize', handleResize);
  
    navbar.addEventListener('scroll', function() {
      updateArrowColor();
    });
  
    navNextBtn.addEventListener('click', function() {
      var lastNavItem = navItems[navItems.length - 1];
      var lastNavItemRight = lastNavItem.getBoundingClientRect().right;
      var diff = Math.min(navbarWidth, lastNavItemRight - navbarWidth);
  
      navbar.scrollBy({
        left: diff,
        behavior: 'smooth'
      });
  
      updateArrowColor();
    });
  
    navPrevBtn.addEventListener('click', function() {
      navbar.scrollLeft = 0;
      updateArrowColor();
    });
  
    updateArrowColor();
  })();
});
document.addEventListener("DOMContentLoaded", function() {
    collection_qv_function();
});
document.addEventListener("DOMContentLoaded", function() {
    var paginationButton = document.querySelector('.m-collection--pagination button');
    var loadMoreButton = document.querySelector('.m-product-tabs__load-more button');

    if (paginationButton) {
        var observer = new MutationObserver(function(mutationsList, observer) {
            if (!paginationButton.classList.contains('m-spinner-loading')) {
                // 加载完成，调用你的功能函数
                collection_qv_function();
            }
        });

        var config = { attributes: true, attributeFilter: ['class'] };

        observer.observe(paginationButton, config);
    } else if (loadMoreButton) {
        // 监测 .m-product-tabs__load-more button
        var observer = new MutationObserver(function(mutationsList, observer) {
            // 添加监测代码
        });

        var config = { attributes: true, attributeFilter: ['class'] };

        observer.observe(loadMoreButton, config);
    } else {
        // 如果两者都不存在则跳过代码
    }
});


function collection_qv_function() {
    
    // 监听目标元素加载的函数
    function waitForElement(selector, callback) {
        const interval = setInterval(function() {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(interval);
                callback(element);
            }
        },
        100); // 每100毫秒检查一次是否出现目标元素
    }

    // 隐藏指定表格并处理其前一个兄弟元素
    function hideTableAndHandlePreviousSibling(table) {
        const previousSibling = table.previousElementSibling;
        const parent = table.parentNode;
        table.style.display = 'none'; // 隐藏表格
        if (previousSibling && previousSibling.textContent.includes("Size Chart")) {
            previousSibling.style.display = 'none'; // 隐藏前一个兄弟元素
        }
    }

    // 查找按钮并添加点击事件监听器
    const buttons = document.querySelectorAll('.m-product-quickview-button');
    buttons.forEach(button =>{
        button.addEventListener('click',function(event) {
            // 等待目标元素加载完毕
            waitForElement('#qv-product-description-contents',function(element) {
                // 目标元素加载完成后执行操作
                //console.log('目标元素加载完成，可以进行下一步操作');

                // 获取所有表格
                const tables = element.querySelectorAll('table');

                // 循环遍历表格
                tables.forEach(table =>{
                    // 如果表格的id不等于"specifications-table"，则隐藏表格并处理前一个同级元素
                    if (table.id !== "specifications-table") {
                        hideTableAndHandlePreviousSibling(table);
                    }
                });

                // 找到内容为 "Size Chart (CM)" 的子元素
                const childElements = Array.from(element.children);
                const sizeChartElement = childElements.find(child =>child.textContent.includes("Size Chart (CM)"));

                if (sizeChartElement) {
                    // 找到该元素的下一个 table 元素
                    const nextTable = sizeChartElement.nextElementSibling;
                    if (nextTable && nextTable.tagName.toLowerCase() === 'table') {
                        // 给找到的表格元素添加 id
                        nextTable.id = 'option-size-detail-table-cm';
                        //console.log('下一个 table 元素（id已设置为 option-size-detail-table-cm）:', nextTable);

                        // 复制表格
                        const clonedTable = nextTable.cloneNode(true);

                        // 设置复制表格的ID
                        clonedTable.id = 'option-size-detail-table';
                        //console.log('复制的 table 元素:', clonedTable);

                        nextTable.parentNode.insertBefore(clonedTable, nextTable.nextSibling);

                        const inchrows = clonedTable.getElementsByTagName('tr');
                        const headerRow = inchrows[0]; // 表头行
                        let skipColumns = []; // 存储需要跳过的列索引
                        // 找到包含“Sizes”的列索引
                        for (let i = 0; i < headerRow.cells.length; i++) {
                            if (headerRow.cells[i].textContent.includes('Sizes')) {
                                skipColumns.push(i);
                            }
                        }

                        for (let i = 0; i < inchrows.length; i++) {
                            const inchcells = inchrows[i].getElementsByTagName('td');
                            for (let j = 0; j < inchcells.length; j++) {
                                if (!skipColumns.includes(j)) { // 如果不在跳过列中
                                    const value = inchcells[j].textContent.trim();
                                    const values = value.split('-').map(parseFloat);
                                    let result;
                                    if (values.length === 2 && !values.some(isNaN)) {
                                        const newValue = values.map(v =>(v / 2.54).toFixed(1));
                                        result = newValue.join('-');
                                    } else if (!isNaN(parseFloat(value))) {
                                        result = (parseFloat(value) / 2.54).toFixed(1);
                                    }
                                    if (result) {
                                        inchcells[j].textContent = result;
                                    }
                                }
                            }
                        }

                        (function() {
                            var table = document.getElementById("option-size-detail-table"); // 获取表格元素
                            var cells = table.getElementsByTagName("td"); // 获取所有单元格元素
                            for (var i = 0; i < cells.length; i++) {
                                var cell = cells[i];
                                if (cell.rowSpan > 1 || cell.colSpan > 1) { // 判断是否为合并单元格
                                    var rowIndex = cell.parentNode.rowIndex; // 获取行索引
                                    var colIndex = cell.cellIndex; // 获取列索引
                                    for (var j = 1; j < cell.rowSpan; j++) { // 添加相应缺失的单元格
                                        var newRow = table.rows[rowIndex + j]; // 获取新行
                                        var newCell = newRow.insertCell(colIndex); // 插入新单元格
                                        newCell.innerHTML = ""; // 设置单元格内容
                                    }
                                    for (var j = 1; j < cell.colSpan; j++) { // 添加相应缺失的单元格
                                        var newCell = cell.parentNode.insertCell(colIndex + 1); // 插入新单元格
                                        newCell.innerHTML = ""; // 设置单元格内容
                                    }
                                    cell.rowSpan = 1; // 取消行合并
                                    cell.colSpan = 1; // 取消列合并
                                }
                            }
                        })();

                        (function() {

                            // 获取表格
                            var table = document.getElementById("option-size-detail-table");

                            // 获取表格中第一行
                            var firstRow = table.rows[0];

                            // 遍历第一行的单元格
                            for (var i = 0; i < firstRow.cells.length; i++) { // 如果单元格是空的，则删除列
                                if (firstRow.cells[i].innerHTML.trim() === "") { // 遍历表格的所有行
                                    for (var j = 0; j < table.rows.length; j++) { // 删除当前列的单元格
                                        table.rows[j].deleteCell(i);
                                    }
                                }
                            }

                        })();

                        (function() {
                            var parentDiv = document.createElement("div");
                            parentDiv.setAttribute("id", "option-size-detail-rows");
                            var table = document.getElementById("option-size-detail-table");
                            var rows = Array.from(table.querySelectorAll("tr")).slice(1);
                            var headerCells = Array.from(table.querySelectorAll("tr:first-child td"));
                            rows.forEach(function(row) {
                                var div = document.createElement("div");
                                var firstCell = row.querySelector("td:first-child").innerText.replace("_", " ");
                                div.setAttribute("data-row-header", firstCell);
                                div.classList.add("option-size-detail-row");
                                div.style.display = "none";
                                var cells = Array.from(row.querySelectorAll("td"));
                                cells.forEach(function(cell, index) {
                                    var cellDiv = document.createElement("div");
                                    cellDiv.classList.add("option-size-detail-cell");
                                    var headerCell = headerCells[index];
                                    var headerText = headerCell.innerText;
                                    if (/^Sizes$/.test(headerText)) {
                                        headerText = headerText.replace("Sizes", "Sizes (Inch)").replace("_", " ");
                                    }
                                    headerText = headerText.replace("_", " ");
                                    var cellText = cell.innerText;
                                    if (index !== 0 && !isNaN(cellText)) {
                                        cellText += " inch";
                                    }
                                    cellDiv.innerHTML = "<div class=\"option-size-detail-cell-header\">" + headerText + ": </div> <div class=\"option-size-detail-cell-text\">" + cellText + "</div>";
                                    div.appendChild(cellDiv);
                                });
                                parentDiv.appendChild(div);
                            });
                            table.parentNode.insertBefore(parentDiv, table.parentNode.firstChild);
                            table.style.display = "none";
                        })();

                        const targetElement = document.querySelector("#option-size-detail");
                        const elementToMove = document.querySelector("#option-size-detail-rows");

                        if (targetElement && elementToMove) {
                            targetElement.appendChild(elementToMove);
                            //console.log("成功将元素移动到目标位置。");
                        } else {
                            //console.log("未找到目标元素或要移动的元素。");
                        }

                        (function() {
                            // 获取数据属性值的元素
                            const dataElement = document.querySelector('.m-product-option-data-size');

                            // 获取需要对比的元素
                            const sizeRows = document.querySelectorAll('.option-size-detail-row');

                            // 创建 MutationObserver 实例
                            const observer = new MutationObserver((mutationsList) =>{
                                for (let mutation of mutationsList) {
                                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-selected-value') {
                                        runComparison();
                                        break;
                                    }
                                }
                            });

                            // 监听数据属性值的变化
                            observer.observe(dataElement, {
                                attributes: true
                            });

                            // 对比函数
                            function runComparison() {
                                const selectedValue = dataElement.getAttribute('data-selected-value');
                                // 去除括号以及括号中的内容
                                const processedSelectedValue = selectedValue.replace(/\([^)]*\)/g, '').trim();

                                let hasVisibleRow = false;
                                sizeRows.forEach((row) =>{
                                    const rowHeader = row.getAttribute('data-row-header');
                                    // 去除括号以及括号中的内容
                                    const processedRowHeader = rowHeader.replace(/\([^)]*\)/g, '').trim();

                                    if (processedSelectedValue === processedRowHeader) {
                                        row.style.display = 'block';
                                        hasVisibleRow = true;
                                    } else {
                                        row.style.display = 'none';
                                    }
                                });

                                if (!hasVisibleRow) {
                                    sizeRows.forEach((row) =>{
                                        const rowHeader = row.getAttribute('data-row-header');
                                        const matchedRowHeader = rowHeader.match(/\(([^)]*)\)/);
                                        const rowHeaderInBrackets = matchedRowHeader ? matchedRowHeader[1] : '';

                                        if (processedSelectedValue === rowHeaderInBrackets) {
                                            row.style.display = 'block';
                                        } else {
                                            row.style.display = 'none';
                                        }
                                    });
                                }
                            }
                        })();

                    } else {
                        //console.log('未找到符合条件的下一个 table 元素');
                    }
                } else {
                    //console.log('未找到内容为 "Size Chart (CM)" 的子元素');
                  // Find all elements with id "option-size-detail-rows" inside elements with class "m-product-quickview"
                  var elementsToRemove = document.querySelectorAll('.m-product-quickview #option-size-detail');
                  
                  // Iterate through each matched element and remove it
                  elementsToRemove.forEach(function(element) {
                      element.parentNode.removeChild(element);
                  });
                  
                  //console.log("All elements with id 'option-size-detail-rows' inside elements with class 'm-product-quickview' have been successfully removed.");
                }
            });
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
    var element = document.querySelector('.m-product-option #option-size-detail');
    if (element && element.innerHTML.trim() === '') {
        element.parentNode.removeChild(element);
        //console.log("Element with id 'option-size-detail' inside class 'm-product-option' has been successfully removed.");
    }
});